import { useEffect, useMemo, useState } from 'react';
import { useDataLayerActions, useProductsFromHandles } from '@hooks';
import FilterBar from '@/snippets/globals/layout/FilterBar.jsx';
import ProductGrid from '@/snippets/globals/layout/ProductGrid.jsx';
import { Filters } from '../icons/Filter';
import CollectionHeader from '../components/CollectionHeader';

function SearchPageContent({ productHandles = [], searchTerm }) {
  const { sendViewSearchResultsEvent } = useDataLayerActions();
  const { products: searchProducts } = useProductsFromHandles({
    handles: productHandles,
  });

  const products = useMemo(() => {
    return Object.values({...searchProducts});
  }, [searchProducts])
  const urlSearchParams = new URLSearchParams(document.location.search);

  const getFiltersFromUrl = () => {
    let filtersArray = [];
    const filters = urlSearchParams.get('filter');
    if (filters) filtersArray = filters.split('|');
    return filtersArray;
  };

  const [layoutParams, setLayoutParams] = useState({
    searchQuery: urlSearchParams.get('search'),
    filters: getFiltersFromUrl(),
  });

  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  let filteredProducts = [...products];
  if (layoutParams?.filters?.length > 0) {
    filteredProducts = filteredProducts?.filter((product) => {
      return product.tags.some((tag) => layoutParams.filters.includes(tag));
    });
  }

  const toggleMobileFilter = () => {
    setMobileFilterOpen((mobileFilterOpen) => {
      let action = 'remove';
      if (!mobileFilterOpen) {
        action = 'add';
      }

      if (typeof window !== 'undefined') {
        document.querySelector('body').classList[action]('overflow-hidden');
      }
      return !mobileFilterOpen;
    });
  };

  useEffect(() => {
    sendViewSearchResultsEvent({
      products,
      isSearchPage: true,
      searchTerm,
    });
  }, [products, sendViewSearchResultsEvent]);

  return (
    <div>
      <FilterBar
        mobileFilterOpen={mobileFilterOpen}
        setMobileFilterOpen={setMobileFilterOpen}
        currentFilters={layoutParams.filters}
        setLayoutParams={setLayoutParams}
        items={products}
        disableSort
      />
      <div
        key="collection-container"
        className="flex gap-x-[120px] px-5 md:mx-auto lg:container"
      >
        <div className="collection__product-grid-container w-full lg:container lg:mx-auto">
          <ProductGrid productList={filteredProducts} isSearch />
        </div>
      </div>
    </div>
  );
}

export default SearchPageContent;
